import React from 'react';
import PropTypes from 'prop-types';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { makeStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import CardAccordion from 'Components/ComponentLibrary/Molecules/CardAccordion';
import LineItem from 'Components/ComponentLibrary/Molecules/LineItem';
import { useSummarySidebarContentContext } from 'Views/Page/Content/Templates/WhatIfTemplate/Content/LeftSide/Content/DetailPicker/Details/Context';
import ListItem2 from 'Components/ComponentLibrary/Components/ListItems/ListItem2';
import ListItemText from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/ListItemText';
import { Paper } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';
import { DataValueMap } from 'Helpers/Testing';
import List1 from 'Components/ComponentLibrary/Components/Lists/List1';
import ListItemSecondaryAction
  from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/ListItemSecondaryAction';
import MetaControl from 'Components/UI/Meta/MetaControl';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import fr from 'facet-rest';
import ItemIcon from './ItemIcon';
import GroupIcon from './GroupIcon';
import AccountSecondaryAction from './AccountSecondaryAction';

const useStyles = makeStyles(theme => ({
  root: {},
  listItem: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
    minHeight: 64,
    paddingRight: theme.spacing(18),
  },
}));

const BalanceSheetTabContent = ({
  tabData,
}) => {
  const { handleViewAccountDetail } = useSummarySidebarContentContext();
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      {tabData.map(tabResource => {
        const itemResources = tabResource.attr('items').resources().list();

        const groups = Object.values(itemResources.reduce((data, acc) => {
          const d = { ...data };
          const accType = acc.attr('type');
          if (!d[accType]) {
            d[accType] = {
              name: acc.attr('type'),
              items: [],
            };
          }
          d[accType].items.push(acc);
          return d;
        }, {})).sort((a, b) => a.name.localeCompare(b.name));

        return (
          <CardAccordion
            key={tabResource.type()}
            test={`facet-plan-balance-sheet-accordion-${tabResource.type()}`}
            HeaderContent={() => {
              return (
                <LineItem
                  icon={<GroupIcon resource={tabResource} />}
                  title={tabResource.attr('title')}
                  value={tabResource.attr('total')}
                />
              );
            }}
            BodyContent={
              <React.Fragment>
                <MetaControl
                  resource={tabResource}
                  attrName={'emptyListDescription'}
                />
                {groups.map((group) => {
                  return (
                    <React.Fragment key={group.name}>
                      <Text value={group.name} align={'left'} />
                      <List1>
                        {group.items.map(itemResource => {
                          const testAttributes = DataValueMap.init('facet-plan-balance-sheet-account-item')
                            .append(DataValueMap.keyMap.dataResourceId, itemResource.id())
                            .append(DataValueMap.keyMap.dataResourceType, itemResource.type())
                            .append(DataValueMap.keyMap.dataAccountId, itemResource.id())
                            .append(DataValueMap.keyMap.dataAccountType, itemResource.attr('accountType'))
                            .append(DataValueMap.keyMap.dataAccountSubType, itemResource.attr('accountSubType'))
                            .append(DataValueMap.keyMap.dataRealAssetType, itemResource.attr('assetType'))
                            .build();

                          return (
                            <ListItem2
                              {...testAttributes}
                              className={classes.listItem}
                              button
                              onClick={() => handleViewAccountDetail(itemResource)}
                              key={itemResource.id()}
                              component={Paper}
                              variant={'subtle'}
                              elevation={1}
                              disabled={!itemResource.relationship(fr.relationships.details.name)}
                            >
                              <ItemIcon resource={itemResource} />
                              <ListItemText
                                primary={itemResource.attr('title')}
                                primaryTypographyProps={{
                                  variant: 'h6',
                                  color: 'primary',
                                }}
                                secondary={itemResource.attr('subtitle')}
                              />
                              <ListItemSecondaryAction>
                                <AccountSecondaryAction virtualAccountResource={itemResource} />
                              </ListItemSecondaryAction>
                            </ListItem2>
                          );
                        })}
                      </List1>
                    </React.Fragment>
                  );
                })}
              </React.Fragment>
            }
          />
        );
      })}
    </Box>
  );
};

BalanceSheetTabContent.propTypes = {
  tabData: PropTypes.array.isRequired,
};

export default BalanceSheetTabContent;
